import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import { useIntl } from 'react-intl'

const TrainPositionBlankRow = ({ themeName }) => {
  const intl = useIntl()
  const locale = intl.locale

  return (
    <li className="d-TrainPosition-stationItem">
      <Link to="/lines/main/trains" className={`d-TrainPosition-lineSwitchButton d-TrainPosition-lineSwitchButton-${themeName} is_prev`}>{MasterData.line(1)[`name_${locale}`]}</Link>

      { /* この div を消すとずれる */}
      <div className="d-TrainPosition-block" />
      <div className="d-TrainPosition-block is_on_station" />
    </li>
  )
}

TrainPositionBlankRow.propTypes = {
  themeName: PropTypes.string.isRequired,
}

export default TrainPositionBlankRow
